'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const Link = require('../../../components/link');

function MerchantLinks({ merchants, routes, experimentName }) {
  return (
    merchants.length > 0 &&
    h(
      '.merchant-links',
      h(
        '.merchant-links-inner',
        {
          'data-bhw': 'PopularStores',
        },
        [
          h(
            'h3.merchant-links-title',
            h(Translate, 'modules.shared.TopBrands')
          ),
          h(
            'ul.merchant-links-list',
            merchants.map(merchant =>
              h(
                'li.merchant-links-item',
                Link({
                  className: 'merchant-links-link',
                  experimentName,
                  attributes: {
                    href: routes.merchant.show.replace(
                      '{merchantSlug}',
                      merchant.merchantSlug
                    ),
                    'data-bhc': `store:${merchant.merchantSlug}`,
                  },
                  text: merchant.merchantName,
                })
              )
            )
          ),
        ]
      )
    )
  );
}

module.exports = MerchantLinks;
